import {TRANSPORTER_NAME , TRANSPOTER_GSTIN, SERVER_URL, UTILITY_SERVER_URL, FRONTEND_BILTY_PRINT, PRINT_SERVER_URL,  QR_SERVER_URL} from "./company"


const USE_OVERLAY = true;

const getLocalFlag = () => {
    try{
        let lo = localStorage.getItem("local_flag") === 'true';
        console.log("Inansdsnns", lo);
      return lo
    } catch(e){
      return false
    }
  }
// var SERVER_URL = ""
if (getLocalFlag()){
    console.log("in if")
    // SERVER_URL = "http://localhost:8000"
    // SERVER_URL = "http://103.180.39.155:8004";
    // SERVER_URL = SERVER_URL_CMP
  }
else{
    console.log("in else")
    // SERVER_URL = "http://localhost:8000"
    // SERVER_URL ="http://43.252.197.62:8001"
    // SERVER_URL = "http://103.180.39.155:8004";
    // SERVER_URL = SERVER_URL_CMP
    // SERVER_URL = `http://${SERVER_IP}:${SERVER_PORT}`;
    // const SERVER_URL = "https://d7edf369be0e55.localhost.run";
}

console.log(SERVER_URL)
export { SERVER_URL, USE_OVERLAY, TRANSPORTER_NAME, TRANSPOTER_GSTIN, UTILITY_SERVER_URL, FRONTEND_BILTY_PRINT, PRINT_SERVER_URL, QR_SERVER_URL };
